import { AdminFormRow } from '@ui';
import { ControlledTextInput } from '../components/inputs/ControlledTextInput';
import { FacilityLocationDetails } from '../components/FacilityLocationDetails';
import { FacilityAdminFormSection } from '../components/sections';

type HospitalFormType = {
  isReadOnly?: boolean;
};

export const HospitalForm = ({ isReadOnly = false }: HospitalFormType) => {
  return (
    <FacilityAdminFormSection title="Donor Hospital Details" isReadOnly={isReadOnly}>
      <AdminFormRow title="Donor Hospital Name" isRequired>
        <ControlledTextInput name="name" aria-label="Donor Hospital Name" isDisabled={isReadOnly} />
      </AdminFormRow>
      <AdminFormRow title="Code">
        <ControlledTextInput name="code" aria-label="Code" isDisabled={isReadOnly} />
      </AdminFormRow>
      <FacilityLocationDetails isReadOnly={isReadOnly} />
    </FacilityAdminFormSection>
  );
};
